import React from 'react';
import { render } from 'react-dom';
import { AppContainer } from 'react-hot-loader';

import App from './header.jsx';

render(<App/>, document.getElementById('root-react'));

if (module.hot) {
    module.hot.accept('./screens/Root/index.jsx', () => {
        render(
            <React.Fragment>
                <AppContainer>
                    <App/>
                </AppContainer>
            </React.Fragment>,
            document.getElementById('root-react'),
        );
    });
}
